import { useState } from 'react';
import { ActionItemStatus, getUserContacts } from '@uplift/api';
import { useL10n } from '@uplift/hooks';
import { BaseDashboardActionItem } from '@uplift/ui-v2';
import { useSharedStyles } from '../../styles';
import { Key } from '@uplift/icons';
import { useCurrentuser } from '@uplift/contexts';
import { useQuery } from '@tanstack/react-query';
import { AddMfaModal } from './MFA/MfaModal';
import { ContactName } from '@uplift/types';

export type AddMfaProps = {
  status: ActionItemStatus;
};

export const AddMfa: React.VFC<AddMfaProps> = ({ status }) => {
  const [ isModalOpen, setIsModalOpen ] = useState(false);
  const handleCloseModal = () => setIsModalOpen(false);
  const l10n = useL10n();
  const me = useCurrentuser();
  const { classes: sharedClasses } = useSharedStyles();
  const { data } = useQuery({
    enabled: status !== ActionItemStatus.done,
    queryKey: [ 'user-contacts', ContactName.mobile ],
    queryFn: async () => {
      const response = await getUserContacts(me?.id);
      const mobile = response.data.find(c => c.name === ContactName.mobile);

      if (mobile.name === 'email') {
        return null;
      }

      return mobile;
    }
  });

  if (status === ActionItemStatus.done) {
    return null;
  }

  return (
    <>
      <BaseDashboardActionItem
        title={l10n.dashboard.actionItems.addMfa.title}
        body={l10n.dashboard.actionItems.addMfa.subtitle}
        bodyClassName={sharedClasses.actionItemSubtitle}
        color="info"
        icon={<Key />}
        action={{
          handleClick: () => setIsModalOpen(true),
          text: l10n.dashboard.actionItems.addMfa.buttonText
        }}
      />
      {isModalOpen && (
        <AddMfaModal
          contactId={data?.id}
          contactName={data?.name}
          isOpen={isModalOpen}
          phone={data?.value}
          closeModal={handleCloseModal}
        />
      )}
    </>
  );
};
